import React from 'react';
import VideoSlide from '../../body/VideoSlide';

const RewardsVideo = () => {
  return <VideoSlide vidSrc={1194418539} />;
};

export default RewardsVideo;
